import React from 'react';
import { NavLink } from 'react-router-dom';
import './EventsSubNav.css';

/**
 * Secondary bar above PublicBottomNav on the events list during Halloween.
 * Tabs: All events · Giveaways. Halloween tab is commented out for now.
 */
const EventsSubNav = () => (
  <nav className="events-subnav" aria-label="Event sections">
    <div className="events-subnav__inner">
      <NavLink
        to="/"
        end
        className={({ isActive }) => `events-subnav__tab${isActive ? ' is-active' : ''}`}
      >
        All events
      </NavLink>
      {/* Halloween tab hidden for now. Restore with the 3-column grid in EventsSubNav.css.
      <NavLink
        to="/halloween"
        end
        className={({ isActive }) =>
          `events-subnav__tab events-subnav__tab--halloween${isActive ? ' is-active' : ''}`
        }
      >
        <svg className="events-subnav__pumpkin" viewBox="0 0 24 24" aria-hidden="true">
          <path
            fill="currentColor"
            d="M12 3.2c.4-1 1.6-1.2 2 .2-.6.3-1 .8-1.1 1.4 2.2.5 4.2 1.8 5.4 3.6 1.5 2.2 1.8 5.2.6 7.6C17.6 18.8 15 20.5 12 20.5S6.4 18.8 5.1 15.8c-1.2-2.4-.9-5.4.6-7.6C6.9 6.4 8.9 5.1 11.1 4.6 11 4 10.6 3.5 10 3.2c.4-1.2 1.6-1.2 2 0z"
          />
        </svg>
        Halloween
      </NavLink>
      */}
      <NavLink
        to="/giveaway"
        end
        className={({ isActive }) => `events-subnav__tab${isActive ? ' is-active' : ''}`}
      >
        Giveaways
      </NavLink>
    </div>
  </nav>
);

export default EventsSubNav;
